import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { BehaviorSubject, map, Observable, of, ReplaySubject, tap } from 'rxjs';
import { AIForms } from './ai-forms';
import { AuthenticatedMediaService } from 'app/modules/shared/services/authenticated-media.service';





@Injectable({ providedIn: 'root' })
export class AIFormsService {
  private apiLink = environment.apiLink
  private _httpClient = inject(HttpClient);
  private _authenticatedMedia = inject(AuthenticatedMediaService);
  companyLogo: any;

  public httpMethods: string[] = ['GET', 'POST', 'PUT', 'DELETE']

  constructor() { 
    this.companyLogo = localStorage.getItem('user_image');
  }

  getAll(
    page: number,
    size: number,
    name?: string,
    dataSourceId?: any,
    departmentId?: any,
    isShared?: boolean,
    ownedBy?: { id: number; role: string }
  ): Observable<AIForms[]> {
    let params = new HttpParams();
    if (name) {
      params = params.append('name', name);
    }
    if (dataSourceId) {
      params = params.append('dataSourceId', dataSourceId);
    }
    if (departmentId) {
      params = params.append('departmentId', departmentId);
    }
    if (isShared === true || isShared === false) {
      params = params.append('isShared', String(isShared));
    }
    if (ownedBy && Number.isFinite(ownedBy.id) && ownedBy.role) {
      params = params.append('ownedById', String(ownedBy.id));
      params = params.append('ownedByRole', ownedBy.role);
    }
    params = params.append('offset', page);
    params = params.append('limit', size);
    return this._httpClient.get<AIForms[]>(this.apiLink + 'hyperform/all-forms', { params });
  }

  create(modal: any) {
    return this._httpClient.post(this.apiLink + 'hyperform/add-form', modal)
  }

  update(modal: any) {
    return this._httpClient.put(this.apiLink + 'hyperform/edit-form', modal)
  }

  updateStatus(formId, datasourceId) {
    let params = new HttpParams();
    params = params.append('formId', formId);
    params = params.append('dataSourceId', datasourceId);
    return this._httpClient.put(this.apiLink + 'hyperform/toggle-form', {}, { params })

  }

  delete(formId, datasourceId) {
    let params = new HttpParams();
    params = params.append('formId', formId);
    params = params.append('dataSourceId', datasourceId);
    return this._httpClient.delete(this.apiLink + 'hyperform/delete-form', { params })
  }

  shareForm(body: {
    formId: number;
    memberIds: number[];
    staffIds: number[];
    userIds: number[];
  }) {
    return this._httpClient.put(this.apiLink + 'hyperform/share-form', body);
  }

  deleteField(formId, datasourceId, fieldId) {
    let params = new HttpParams();
    params = params.append('formId', formId);
    params = params.append('dataSourceId', datasourceId);
    params = params.append('fieldId', fieldId);
    return this._httpClient.delete(this.apiLink + 'hyperform/delete-field', { params })
  }


  getFormDetails(formId, datasourceId) {
    return this._httpClient.get(this.apiLink + `hyperform/form?dataSourceId=${datasourceId}&formId=${formId}`)
  }

  addDataToForm(modal) {
    return this._httpClient.post(this.apiLink + '/form/add-form-data', modal)
  }

  saveQr(body) {
    return this._httpClient.post(this.apiLink + 'hyperform/add-qrlink', body)
  }


  generateQrCode(name?): Promise<string> {
    return new Promise((resolve) => {
      const canvas = document.createElement('canvas');
      const size = 500; // Size of the image
      canvas.width = size;
      canvas.height = size;
      const ctx = canvas.getContext('2d');

      // Draw rounded image
      const img = new Image();
      img.crossOrigin = 'anonymous'; // To handle cross-origin images

      // `companyLogo` (from `localStorage['user_image']`) may be an authenticated API path
      // (`uploads/get-file?type=profile-image&…`) — a raw `Image()` load cannot send
      // `Authorization`, so resolve it through the shared blob-fetch service (same pattern as
      // `[authSrc]`) before assigning `img.src`, instead of hitting the API unauthenticated (403).
      this._authenticatedMedia.resolve(this.companyLogo).subscribe((resolvedSrc) => {
        if (!resolvedSrc) {
          resolve(canvas.toDataURL());
          return;
        }
        img.src = resolvedSrc;
      });

      img.onload = () => {
        // Draw rounded rectangle for the image
        // ctx.beginPath();
        // ctx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2, true);
        // ctx.closePath();
        // ctx.clip();

        // ctx.drawImage(img, 0, 0, size, size);

        // Draw text in the center
        // ctx.font = 'bold 100px Arial';
        // ctx.fillStyle = 'white';
        // ctx.textAlign = 'center';
        // ctx.textBaseline = 'middle';
        // ctx.fillText(name, size / 2, size / 2);

        // Resolve the promise with the image data URL
        resolve(canvas.toDataURL());
      };

      img.onerror = () => {
        // In case of an error, resolve with a fallback (blank) data URL
        resolve(canvas.toDataURL());
      };
    });
  }

convertSameDomainImage(url: string): Promise<string> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx?.drawImage(img, 0, 0);
      resolve(canvas.toDataURL());
    };

    img.onerror = reject;

    img.src = url; // No crossOrigin needed
  });
}

}

